import React, { useContext, useEffect } from "react";
import { Outlet, Navigate } from "react-router-dom";
import ReactGA from "react-ga4";

import { LoginContext } from "../context/login-context";

const LOGIN_PATH = "/login";

function ProtectedLayout(props) {
  const { runProtected, state: userData } = useContext(LoginContext);

  useEffect(() => {
    ReactGA.set({
      user_id: userData?.id,
      customer_id: userData?.customer_id,
      customer_name: userData?.customer?.name,
      is_admin: userData?.admin?.toString()
    });
  }, [userData]);

  if (!userData?.id) {
    return <Navigate to={LOGIN_PATH} replace></Navigate>;
  }

  if(props.allowedRoles && !props.allowedRoles.includes(userData.user_role)){
    return <Navigate to={'/'} replace></Navigate>;
  }

  return <Outlet />;
}

export default ProtectedLayout;
